export default __webpack_public_path__ + "static/media/loading-stamp-1.c1291543.jpg";